/* Custom SVG inspired by the Trésors de Guyane brand emblem (topographic Mt Itoupé) */
export const TopoEmblem = ({ className = "", color = "currentColor" }) => (
  <svg viewBox="0 0 80 80" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
      <path d="M14 60 C 12 50, 16 38, 22 32 C 28 26, 30 18, 38 16 C 44 14, 48 22, 50 28 C 52 36, 58 36, 62 42 C 66 48, 64 56, 58 60 C 50 66, 42 64, 36 66 C 28 68, 20 68, 14 60 Z" />
      <path d="M20 56 C 20 48, 22 40, 28 36 C 34 32, 36 28, 40 26 C 44 24, 48 30, 50 34 C 52 40, 56 42, 58 46 C 60 50, 56 56, 50 58 C 44 60, 38 60, 32 60 C 26 60, 22 60, 20 56 Z" />
      <path d="M28 50 C 28 44, 32 40, 36 38 C 40 36, 44 38, 46 42 C 48 46, 50 48, 50 52 C 50 54, 44 56, 38 56 C 32 56, 28 54, 28 50 Z" />
      <path d="M36 48 C 36 46, 38 44, 40 44 C 42 44, 44 46, 44 48 C 44 50, 42 50, 40 50 C 38 50, 36 50, 36 48 Z" />
    </g>
  </svg>
);

export const BrandLockup = ({ className = "", inverse = false }) => {
  const fg = inverse ? "var(--tdg-cream)" : "var(--tdg-green)";
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="header-logo">
      <div
        className="border-2 flex items-center justify-center"
        style={{ width: 38, height: 38, borderColor: fg, background: inverse ? "transparent" : "transparent" }}
      >
        <TopoEmblem className="w-7 h-7" color={fg} />
      </div>
      <div className="flex flex-col leading-none">
        <span className="font-display text-[15px] tracking-[0.18em]" style={{ color: fg, lineHeight: 1 }}>
          TRÉSORS
        </span>
        <span className="font-display text-[15px] tracking-[0.18em] mt-0.5" style={{ color: fg, lineHeight: 1 }}>
          DE GUYANE
        </span>
      </div>
    </div>
  );
};

export default BrandLockup;
